import axios from "axios";
import { AUTH_TOKEN, BACKEND_URL,BACKEND_CDN_URL, BACKEND_LATEST_URL } from "./urls";

// /api/v1 
const customInstance = axios.create({
  baseURL: BACKEND_URL,
});

// /api/latest
export const axiosLatest = axios.create({
  baseURL: BACKEND_LATEST_URL
});

if (process.env.REACT_APP_ENVIRONMENT === "LOCALHOST")
  customInstance.defaults.headers.common["Authorization"] = axiosLatest.defaults.headers.common["Authorization"] = AUTH_TOKEN;
else 
  customInstance.defaults.withCredentials = axiosLatest.defaults.withCredentials = true;


export default customInstance;

//use this axios for calling api without credentials
export const axiosWC = axios.create({
  baseURL: BACKEND_CDN_URL,
});
